// extracted by mini-css-extract-plugin
module.exports =  {"label":"selectize-module_label_ce8bd","required":"selectize-module_required_ba691","wrapper":"selectize-module_wrapper_c5dc4","closeIcon":"selectize-module_closeIcon_d2316"};